module.exports = __webpack_public_path__ + "img/hgMainFooter.b032d10a.jpg";